import * as React from 'react';
export const onpointSvg = React.forwardRef(function onpointSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0781AD',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M17.28 15.86c0 3.07-2.1 6.63-6.05 6.63-3.94 0-6.04-3.56-6.04-6.63 0-3.16 2.2-6.35 6.04-6.35 3.86 0 6.07 3.18 6.07 6.35h-.02zm-6.02-5.48c2.9 0 4.29 2.94 4.3 5.47 0 2.8-1.52 5.77-4.32 5.77-2.8 0-4.32-2.99-4.32-5.77.02-2.53 1.43-5.47 4.34-5.47zm13.77 12.1v-6.3c0-1.43-1.08-2.2-2.66-2.18-.95.02-1.86.38-2.42.72v7.77h-1.79v-7.97A8.35 8.35 0 0 1 21 13.26c.9-.21 2.1-.42 3.36-.18 1.31.25 2.45 1.06 2.45 2.3v7.09h-1.78v.02z',
      }),
    ),
  );
});
onpointSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var onpoint = {
  category: 'brand',
  colorable: false,
  name: 'onpoint',
  svg: onpointSvg,
};
